/* JungleSocks × One Piece — JS de las secciones OP (sin dependencias) */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = !!(window.Shopify && window.Shopify.designMode);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Revelado al hacer scroll (desactivado en el editor y con movimiento reducido) */
  let io;
  function initReveal(scope) {
    if (reduce || inEditor || !('IntersectionObserver' in window)) return;
    io = io || new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    }), { threshold: 0.06 });
    scope.querySelectorAll('[data-rv]:not(.op-rv-init)').forEach(el => {
      if (el.getBoundingClientRect().top < window.innerHeight) return; // ya visible: sin animación
      el.classList.add('op-rv-init');
      io.observe(el);
    });
  }

  /* Talla elegida → texto del botón «Añadir · M» */
  function syncSize(form) {
    const checked = form.querySelector('input[type="radio"][name="id"]:checked');
    const label = form.querySelector('[data-op-size]');
    if (checked && label) label.textContent = checked.dataset.size;
  }
  document.addEventListener('change', e => {
    if (e.target.matches('.op-buy input[type="radio"]')) syncSize(e.target.form);
  });

  /* ---------- Carrito lateral ---------- */
  const CART_SECTION = 'op-cart-drawer';
  const drawer = () => document.querySelector('[data-op-cart]');
  let lastFocus = null;

  function renderCart(html) {
    const d = drawer();
    if (!d || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-op-cart-content]');
    const cur = d.querySelector('[data-op-cart-content]');
    if (fresh && cur) cur.replaceWith(fresh);
    const n = fresh ? fresh.dataset.opCount : null;
    if (n != null) document.querySelectorAll('[data-op-cart-count]').forEach(el => { el.textContent = n; });
  }
  async function refreshCart() {
    const res = await fetch(root + '?sections=' + CART_SECTION, { headers: { Accept: 'application/json' } });
    if (res.ok) renderCart((await res.json())[CART_SECTION]);
  }
  function trapFocus(e) {
    const d = drawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeCart(); return; }
    if (e.key !== 'Tab') return;
    const f = [...d.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]')].filter(el => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openCart(refresh) {
    const d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    document.documentElement.classList.add('op-cart-lock');
    const panel = d.querySelector('.op-cart__panel');
    setTimeout(() => panel && panel.focus({ preventScroll: true }), 50);
    document.addEventListener('keydown', trapFocus);
    if (refresh) refreshCart().catch(() => {});
    return true;
  }
  function closeCart() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('op-cart-lock');
    document.removeEventListener('keydown', trapFocus);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  async function changeLine(line, quantity) {
    const d = drawer();
    d.classList.add('is-loading');
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: CART_SECTION, sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      renderCart(data.sections && data.sections[CART_SECTION]);
      document.dispatchEvent(new CustomEvent('op:cart-updated', { detail: data }));
    } catch (err) {
      const box = d.querySelector('[data-op-cart-error]');
      if (box) { box.textContent = err.message; box.hidden = false; }
    }
    d.classList.remove('is-loading');
  }
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-op-cart-open]');
    if (open && drawer()) { e.preventDefault(); openCart(true); return; }
    if (e.target.closest('[data-op-cart-close]')) { closeCart(); return; }
    if (e.target.closest('[data-op-cart-close-link]')) {
      const href = e.target.closest('a').getAttribute('href') || '';
      if (href.startsWith('#')) closeCart();
      return;
    }
    const q = e.target.closest('[data-op-cart] [data-op-line]');
    if (q) changeLine(q.dataset.opLine, q.dataset.q);
  });
  /* Editor de temas: abrir el carrito al seleccionar su sección */
  document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('[data-op-cart]')) openCart(false); });
  document.addEventListener('shopify:section:deselect', e => { if (e.target.querySelector('[data-op-cart]')) closeCart(); });

  /* Añadir al carrito sin recargar (y abrir el carrito lateral) */
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form.op-js-add');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const html = btn ? btn.innerHTML : '';
    if (btn) btn.disabled = true;
    const d = drawer();
    try {
      const body = new FormData(form);
      if (d) { body.append('sections', CART_SECTION); body.append('sections_url', location.pathname); }
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      if (d && data.sections) {
        renderCart(data.sections[CART_SECTION]);
      } else {
        const cart = await (await fetch(root + 'cart.js')).json();
        document.querySelectorAll('[data-op-cart-count]').forEach(n => { n.textContent = cart.item_count; });
      }
      document.dispatchEvent(new CustomEvent('op:cart-updated', { detail: data }));
      if (btn) btn.textContent = btn.dataset.added || '✓';
      if (d && d.hasAttribute('data-open-on-add')) openCart(false);
    } catch (err) {
      if (btn) btn.textContent = err.message;
    }
    setTimeout(() => {
      if (!btn) return;
      btn.innerHTML = html;
      btn.disabled = false;
      syncSize(form);
    }, 1800);
  });

  /* FAQ: solo una abierta */
  document.addEventListener('toggle', e => {
    const d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    const list = d.closest('[data-op-single]');
    if (list) list.querySelectorAll('details[open]').forEach(o => { if (o !== d) o.open = false; });
  }, true);

  /* ---------- Cofre del tesoro: escena ligada al scroll ---------- */
  const clamp01 = v => v < 0 ? 0 : v > 1 ? 1 : v;
  const seg = (p, a, b) => clamp01((p - a) / (b - a));
  const lerp = (a, b, t) => a + (b - a) * t;
  const easeOut = t => 1 - Math.pow(1 - t, 3);
  const easeInOut = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  const easeOutBack = t => { const c = 1.5; return 1 + (c + 1) * Math.pow(t - 1, 3) + c * Math.pow(t - 1, 2); };

  class OpTreasure {
    constructor(sec) {
      this.sec = sec;
      this.stage = sec.querySelector('.op-tr__stage');
      this.back = sec.querySelector('.op-tr__back');
      this.front = sec.querySelector('.op-tr__front');
      this.lid = sec.querySelector('.op-tr__lid');
      this.glow = sec.querySelector('.op-tr__glow');
      this.rays = sec.querySelector('.op-tr__rays');
      this.intro = sec.querySelector('.op-tr__intro');
      this.more = sec.querySelector('.op-tr__more');
      this.outro = sec.querySelector('.op-tr__outro');
      this.items = [...sec.querySelectorAll('.op-tr__item')];
      this.coins = [...sec.querySelectorAll('.op-tr__coin')].map((el, k) => ({
        el,
        a: (-165 + ((k * 47) % 150)) * Math.PI / 180,   // ángulo hacia arriba, repartido
        d: .55 + ((k * 37) % 45) / 100,                  // distancia relativa
        r: (k * 73) % 360
      }));
      this.formMode = !!sec.querySelector('.op-tr__outro--form');
      this.auto = sec.hasAttribute('data-auto');
      this.duration = parseFloat(sec.dataset.duration) || 4500;
      this.cur = 0; this.target = 0; this.raf = 0;
      sec.classList.add('is-animated');
      this.onScroll = () => this.request();
      this.onResize = () => { this.measure(); this.request(true); };
      window.addEventListener('resize', this.onResize);
      if (this.auto) {
        sec.classList.add('is-auto');
        if (this.more) { this.more.remove(); this.more = null; }
        this.bindAuto();
      } else {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
      this.measure();
      this.request(true);
      // Si hay imagen sobre el título final, recalculamos cuando cargue (cambia el alto del bloque)
      sec.querySelectorAll('.op-tr__outro img').forEach(img => {
        if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
      });
    }
    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      if (this.unbindAuto) this.unbindAuto();
      this.unlock();
      cancelAnimationFrame(this.raf);
      this.sec.classList.remove('is-animated', 'is-auto', 'is-played');
    }

    /* ----- Modo automático: un desliz (o tocar el cofre) abre todo de una vez ----- */
    visibleRatio() {
      const r = this.sec.getBoundingClientRect();
      const vis = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
      return Math.max(0, vis) / Math.min(r.height || 1, window.innerHeight);
    }
    bindAuto() {
      const startedVisible = this.visibleRatio() > .5;
      let touchY = null;
      const intent = e => {
        if (this.played) return;
        if (this.visibleRatio() < .5) return;          // aún no está en pantalla: dejamos hacer scroll hasta él
        if (e && e.cancelable) e.preventDefault();
        this.play();
      };
      const onWheel = e => {
        if (this.playing) { if (e.cancelable) e.preventDefault(); return; }
        if (e.deltaY > 0) intent(e);
      };
      const onTouchStart = e => { touchY = e.touches[0].clientY; };
      const onTouchMove = e => {
        if (this.playing) { if (e.cancelable) e.preventDefault(); return; }
        if (touchY != null && touchY - e.touches[0].clientY > 8) intent(e);
      };
      const onKey = e => {
        if (this.playing && ['ArrowDown', 'PageDown', ' ', 'Spacebar', 'End'].includes(e.key)) { e.preventDefault(); return; }
        if (['ArrowDown', 'PageDown', ' ', 'Spacebar'].includes(e.key) && !e.target.closest('input, textarea, select, button, a')) intent(e);
      };
      const onClick = e => {
        if (this.played || e.target.closest('a, button, input, label, form')) return;
        this.play();
      };
      window.addEventListener('wheel', onWheel, { passive: false });
      window.addEventListener('touchstart', onTouchStart, { passive: true });
      window.addEventListener('touchmove', onTouchMove, { passive: false });
      window.addEventListener('keydown', onKey);
      this.stage.addEventListener('click', onClick);
      // Si la sección está más abajo en la página, se abre sola al llegar a ella
      let io = null;
      if (!startedVisible && 'IntersectionObserver' in window) {
        io = new IntersectionObserver(es => es.forEach(en => { if (en.intersectionRatio >= .6) this.play(); }), { threshold: [.6] });
        io.observe(this.sec);
      }
      this.unbindAuto = () => {
        window.removeEventListener('wheel', onWheel);
        window.removeEventListener('touchstart', onTouchStart);
        window.removeEventListener('touchmove', onTouchMove);
        window.removeEventListener('keydown', onKey);
        this.stage.removeEventListener('click', onClick);
        if (io) io.disconnect();
      };
    }
    lock() { document.documentElement.classList.add('op-tr-lock'); }
    unlock() { document.documentElement.classList.remove('op-tr-lock'); }
    alignTop() {
      const hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--op-header-h')) || 0;
      window.scrollTo({ top: Math.max(0, this.sec.getBoundingClientRect().top + window.scrollY - hh), behavior: 'auto' });
    }
    play() {
      if (this.played) return;
      this.played = this.playing = true;
      this.sec.classList.add('is-played');
      this.alignTop();
      this.lock();
      const t0 = performance.now(), from = this.cur;
      const step = now => {
        const p = Math.min(1, from + (now - t0) / this.duration);
        this.cur = p; this.render(p);
        if (p < 1) this.raf = requestAnimationFrame(step);
        else { this.playing = false; this.unlock(); }
      };
      this.raf = requestAnimationFrame(step);
    }
    finish() {
      cancelAnimationFrame(this.raf);
      this.played = true; this.playing = false;
      this.sec.classList.add('is-played');
      this.unlock();
      this.cur = 1; this.render(1);
    }
    measure() {
      const W = this.W = this.stage.clientWidth;
      const H = this.H = this.stage.clientHeight;
      const gut = Math.max(16, Math.min(40, W * .032));
      const n = this.items.length || 1;
      this.cw = Math.min(W * .62, 460, H * .46);
      this.baseH = this.cw * 220 / 360 * (360 / 400);   // alto del cuerpo (400×220)
      this.chestH = this.cw * 360 / 400;
      this.stage.style.setProperty('--op-chest-w', this.cw + 'px');
      this.sF = .72;                                   // escala final del cofre
      this.bottom = H * .97;
      const introBottom = this.intro.offsetTop + this.intro.offsetHeight;
      this.s0 = Math.max(.55, Math.min(1, (this.bottom - introBottom - 20) / this.chestH)); // no tapar el texto inicial
      this.sF = Math.min(this.sF, this.s0);
      const mouthF = this.bottom - this.baseH * this.sF;
      const outroBottom = this.outro.offsetTop + this.outro.offsetHeight;
      // Modo formulario: el cofre sale por abajo al final y las tarjetas ocupan el hueco bajo el formulario
      const top = outroBottom + 18;
      const floor = this.formMode ? H - Math.max(16, H * .03) : mouthF - 24;
      const avail = Math.max(60, floor - top);
      const gap = Math.max(10, W * .018);
      // Probamos 1 fila y 2 filas y nos quedamos con la que deja las tarjetas más grandes
      const options = [...new Set([n, Math.ceil(n / 2)])].map(cols => {
        const w = Math.min(240, (W - 2 * gut - (cols - 1) * gap) / cols, H * .3);
        this.stage.style.setProperty('--op-card-w', w + 'px');
        const h = Math.max(w * 1.3, ...this.items.map(el => el.offsetHeight));
        const rows = Math.ceil(n / cols);
        const blockH = rows * h + (rows - 1) * gap;
        const fs = Math.min(1, avail / blockH);
        return { cols, w, h, rows, blockH, fs, score: w * fs };
      });
      const best = options.reduce((a, b) => (b.score > a.score ? b : a));
      const { cols, rows } = best, cardW = best.w, cardH = best.h;
      this.stage.style.setProperty('--op-card-w', cardW + 'px');
      this.fs = best.fs;
      const y0 = top + (avail - best.blockH * this.fs) / 2;
      this.cardW = cardW; this.cardH = cardH;
      this.targets = this.items.map((_, i) => {
        const row = Math.floor(i / cols), col = i % cols;
        const inRow = row === rows - 1 ? n - row * cols : cols;
        return {
          x: W / 2 + (col - (inRow - 1) / 2) * (cardW + gap) * this.fs,
          y: y0 + (row * (cardH + gap) + cardH / 2) * this.fs,
          r: (i % 2 ? 1 : -1) * 2.5
        };
      });
    }
    request(jump) {
      if (this.auto) { this.render(this.cur); return; }
      const rect = this.sec.getBoundingClientRect();
      const total = this.sec.offsetHeight - this.H - (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--op-header-h')) || 0);
      const hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--op-header-h')) || 0;
      this.target = clamp01((hh - rect.top) / (total || 1));
      if (jump) this.cur = this.target;
      if (!this.raf) { this.last = 0; this.raf = requestAnimationFrame(t => this.tick(t)); }
    }
    tick(now) {
      this.raf = 0;
      const dt = Math.min(100, now - (this.last || now - 16)); this.last = now;
      this.cur += (this.target - this.cur) * (1 - Math.exp(-dt / 90)); // suavizado independiente de los FPS
      if (Math.abs(this.target - this.cur) < .0005) this.cur = this.target;
      this.render(this.cur);
      if (this.cur !== this.target) this.raf = requestAnimationFrame(t => this.tick(t));
    }
    render(p) {
      const { W, H } = this;
      const open = easeInOut(seg(p, .04, .22));
      const move = easeInOut(seg(p, .22, .6));
      const s = lerp(this.s0, this.sF, move);
      const shake = seg(p, 0, .04) * (1 - open);
      const rot = Math.sin(p * 420) * 2.2 * shake;
      const exit = this.formMode ? easeInOut(seg(p, .64, .86)) * this.chestH * 1.25 : 0;
      const chestT = `translate(${W / 2 - this.cw / 2}px, ${this.bottom - this.chestH + exit}px) scale(${s}) rotate(${rot}deg)`;
      this.back.style.transform = chestT;
      this.front.style.transform = chestT;
      this.lid.style.setProperty('--lf', 1 - easeInOut(seg(open, 0, .5)));
      this.lid.style.setProperty('--lb', easeOut(seg(open, .45, 1)));
      this.back.style.setProperty('--glow-o', open);
      this.back.style.setProperty('--glow-s', .25 + open * .9 + move * .25);

      const mx = W / 2, my = this.bottom - this.baseH * s + exit;

      if (this.rays) {
        this.rays.style.top = my + 'px';
        this.rays.style.opacity = open * (1 - .6 * seg(p, .85, 1));
      }
      const intro = seg(p, .015, .13);
      this.intro.style.opacity = 1 - intro;
      this.intro.style.transform = `translateY(${-40 * intro}px)`;
      this.intro.style.visibility = intro >= 1 ? 'hidden' : 'visible';

      const c = seg(p, .1, .42);
      this.coins.forEach(k => {
        const d = k.d * easeOut(c);
        const x = mx + Math.cos(k.a) * d * W * .42;
        const y = my + Math.sin(k.a) * d * H * .55 + c * c * H * .45;
        k.el.style.transform = `translate(${x}px, ${y}px) rotate(${k.r + c * 540}deg)`;
        k.el.style.opacity = c > 0 && c < 1 ? Math.min(1, c * 6) * (1 - c) : 0;
      });

      const n = this.items.length, w = .34;
      const step = n > 1 ? (.84 - .24 - w) / (n - 1) : 0;
      this.items.forEach((el, i) => {
        const l = seg(p, .24 + i * step, .24 + i * step + w);
        const rise = easeOut(seg(l, 0, .45));
        const fly = easeInOut(seg(l, .38, 1));
        const t = this.targets[i];
        const sx = mx, sy = my + this.cardH * .45;
        const rx = mx + (i - (n - 1) / 2) * this.cardW * .22, ry = my - H * .2;
        const rr = (i - (n - 1) / 2) * 7;
        const x = lerp(lerp(sx, rx, rise), t.x, fly);
        const y = lerp(lerp(sy, ry, rise), t.y, fly);
        const sc = lerp(lerp(.25, .72, rise), this.fs, easeOutBack(fly));
        const r = lerp(lerp(0, rr, rise), t.r, fly);
        el.style.transform = `translate(${x - this.cardW / 2}px, ${y - this.cardH / 2}px) scale(${sc}) rotate(${r}deg)`;
        el.style.opacity = Math.min(1, l * 10);
        el.style.visibility = l > 0 ? 'visible' : 'hidden';
        el.style.setProperty('--lab', seg(fly, .7, 1));
        el.style.pointerEvents = fly > .95 ? 'auto' : 'none';
      });

      // «¡Sigue deslizando!»: desde que se abre el cofre hasta que el último producto llega a su sitio
      if (this.more) {
        const lastEnd = .24 + (n - 1) * step + w;
        const m = seg(p, .11, .17) * (1 - seg(p, lastEnd - .05, lastEnd));
        this.more.style.opacity = m;
        this.more.style.transform = `translate(-50%, ${(1 - m) * -12}px)`;
        this.more.style.visibility = m > 0 ? 'visible' : 'hidden';
      }

      const o = seg(p, .84, .95);
      this.outro.style.opacity = o;
      this.outro.style.transform = `translateY(${30 * (1 - o)}px)`;
      this.outro.style.pointerEvents = o > .9 ? 'auto' : 'none';
    }
  }
  /* Acceso exclusivo: desbloqueo, copiar código, saltos al formulario */
  function unlock(sec) {
    sec.classList.add('is-unlocked');
    sec.querySelectorAll('.op-tr__card[aria-disabled]').forEach(a => { a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); });
  }
  function scrollToEnd(sec, smooth) {
    const tr = typeof treasures !== 'undefined' && treasures.get(sec);
    if (tr && tr.auto) { tr.finish(); tr.alignTop(); return; }
    const end = sec.getBoundingClientRect().top + window.scrollY + sec.offsetHeight - window.innerHeight;
    window.scrollTo({ top: Math.max(end, 0), behavior: smooth && !reduce ? 'smooth' : 'auto' });
  }
  const REG_KEY = 'op-registered';
  function initAccess(scope) {
    scope.querySelectorAll('[data-op-treasure]').forEach(sec => {
      // Recién registrado: el navegador lo recuerda para las próximas visitas
      if (sec.querySelector('[data-op-success]')) { try { localStorage.setItem(REG_KEY, '1'); } catch (e) {} }
      // Ya registrado en este navegador: mensaje en lugar del formulario
      let reg = null; try { reg = localStorage.getItem(REG_KEY); } catch (e) {}
      const remembered = sec.querySelector('[data-op-remembered]'), signup = sec.querySelector('[data-op-signup]');
      if (reg && remembered && signup && !sec.querySelector('[data-op-jump], [data-op-success]')) {
        remembered.hidden = false; signup.hidden = true;
        const t = treasures.get(sec); if (t) { t.measure(); t.request(true); }
      }
      // Tras enviar el formulario, Shopify vuelve con #id-del-formulario y el navegador salta a mitad de la escena.
      // Lo llevamos al final (mensaje visible) y quitamos el ancla para que no vuelva a saltar.
      const hashEl = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
      const fromForm = !!(hashEl && sec.contains(hashEl));
      if (!inEditor && (fromForm || sec.querySelector('[data-op-success], [data-op-jump]'))) {
        if (fromForm) history.replaceState(null, '', location.pathname + location.search);
        if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
        const go = () => { scrollToEnd(sec, false); const t = treasures.get(sec); if (t) t.request(true); };
        requestAnimationFrame(go);
        window.addEventListener('load', () => { go(); setTimeout(go, 120); }, { once: true });
      }
    });
  }
  document.addEventListener('click', e => {
    const locked = e.target.closest('[data-locked]:not(.is-unlocked) .op-tr__card');
    if (locked) { e.preventDefault(); return; }
    const skip = e.target.closest('[data-op-skip-end]');
    if (skip) {
      e.preventDefault();
      const sec = skip.closest('[data-op-treasure]');
      scrollToEnd(sec, false);
      setTimeout(() => { const i = sec.querySelector('.op-tr__input'); if (i) i.focus({ preventScroll: true }); }, 400);
      return;
    }
    const other = e.target.closest('[data-op-other-email]');
    if (other) {
      const sec = other.closest('[data-op-treasure]');
      sec.querySelector('[data-op-remembered]').hidden = true;
      sec.querySelector('[data-op-signup]').hidden = false;
      const t = treasures.get(sec); if (t) { t.measure(); t.request(true); }
      const i = sec.querySelector('.op-tr__input[type="email"]'); if (i) i.focus();
      return;
    }
    const copy = e.target.closest('[data-op-copy]');
    if (copy && navigator.clipboard) {
      navigator.clipboard.writeText(copy.dataset.opCopy).then(() => {
        const span = copy.querySelector('span'); const old = span.textContent;
        span.textContent = copy.dataset.copied || '✓';
        setTimeout(() => { span.textContent = old; }, 1800);
      });
    }
  });
  /* Si alguien llega al formulario con el tabulador mientras está oculto, lo llevamos al final */
  document.addEventListener('focusin', e => {
    const outro = e.target.closest('.is-animated .op-tr__outro');
    if (outro && parseFloat(outro.style.opacity || '0') < .9) scrollToEnd(outro.closest('[data-op-treasure]'), false);
  });

  /* ---------- Hero: vídeo (pausa/sonido, movimiento reducido, pausa fuera de pantalla) ---------- */
  let vio;
  function initVideos(scope) {
    scope.querySelectorAll('[data-op-video]:not(.op-v-init)').forEach(wrap => {
      wrap.classList.add('op-v-init');
      const v = wrap.querySelector('video');
      if (!v) return;
      v.muted = true; v.playsInline = true;
      const sync = () => {
        wrap.classList.toggle('is-paused', v.paused);
        wrap.classList.toggle('is-muted', v.muted);
        const pb = wrap.querySelector('[data-op-vplay]'), sb = wrap.querySelector('[data-op-vsound]');
        if (pb) pb.setAttribute('aria-label', v.paused ? pb.dataset.labelPlay : pb.dataset.labelPause);
        if (sb) sb.setAttribute('aria-label', v.muted ? sb.dataset.labelUnmute : sb.dataset.labelMute);
      };
      ['play', 'pause', 'volumechange'].forEach(ev => v.addEventListener(ev, sync));
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); wrap.dataset.userPaused = '1'; }
      else if (v.paused) v.play().catch(() => {});
      if ('IntersectionObserver' in window) {
        vio = vio || new IntersectionObserver(es => es.forEach(e => {
          const w = e.target, vid = w.querySelector('video');
          if (!vid || w.dataset.userPaused) return;
          if (e.isIntersecting) vid.play().catch(() => {}); else vid.pause();
        }), { threshold: .15 });
        vio.observe(wrap);
      }
      sync();
    });
  }
  document.addEventListener('click', e => {
    const pb = e.target.closest('[data-op-vplay]'), sb = e.target.closest('[data-op-vsound]');
    if (!pb && !sb) return;
    const wrap = e.target.closest('[data-op-video]'), v = wrap && wrap.querySelector('video');
    if (!v) return;
    if (pb) {
      if (v.paused) { delete wrap.dataset.userPaused; v.play().catch(() => {}); }
      else { wrap.dataset.userPaused = '1'; v.pause(); }
    } else {
      v.muted = !v.muted;
      if (!v.muted && v.paused) { delete wrap.dataset.userPaused; v.play().catch(() => {}); }
    }
  });

  /* ---------- Anatomía: puntos ↔ lista ---------- */
  function setHot(sec, i) {
    sec.querySelectorAll('[data-op-hot]').forEach(h => {
      const on = h.dataset.opHot === String(i);
      h.classList.toggle('is-active', on);
      h.setAttribute('aria-pressed', on);
    });
    sec.querySelectorAll('[data-op-hot-item]').forEach(li => li.classList.toggle('is-active', li.dataset.opHotItem === String(i)));
  }
  const hotFrom = e => {
    const h = e.target.closest && e.target.closest('[data-op-hot], [data-op-hot-item]');
    if (!h) return null;
    const sec = h.closest('[data-op-anatomy]');
    return sec ? { sec, i: h.dataset.opHot || h.dataset.opHotItem, el: h } : null;
  };
  ['mouseover', 'focusin'].forEach(ev => document.addEventListener(ev, e => {
    const r = hotFrom(e); if (r) setHot(r.sec, r.i);
  }));
  document.addEventListener('click', e => {
    const r = hotFrom(e); if (!r) return;
    setHot(r.sec, r.i);
    // En móvil, al tocar un punto se muestra su explicación en la lista
    if (r.el.hasAttribute('data-op-hot') && window.matchMedia('(max-width: 989px)').matches) {
      const li = r.sec.querySelector('[data-op-hot-item="' + r.i + '"]');
      if (li) li.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
    }
  });
  document.addEventListener('shopify:block:select', e => {
    const h = e.target.closest && e.target.closest('[data-op-hot]');
    if (h) setHot(h.closest('[data-op-anatomy]'), h.dataset.opHot);
  });

  /* ---------- Menú de la landing: altura de cabecera fija y enlace activo ---------- */
  function initNav() {
    const header = document.querySelector('.op-header--sticky');
    const setH = () => {
      document.documentElement.style.setProperty('--op-header-h', header ? header.offsetHeight + 'px' : '0px');
      if (header) header.classList.toggle('is-stuck', window.scrollY > 4);
    };
    setH();
    window.addEventListener('resize', setH);
    window.addEventListener('scroll', () => { if (header) header.classList.toggle('is-stuck', window.scrollY > 4); }, { passive: true });

    const links = [...document.querySelectorAll('[data-op-nav] a[href^="#"]')];
    const map = new Map();
    links.forEach(a => {
      const id = decodeURIComponent(a.getAttribute('href').slice(1));
      const el = id && document.getElementById(id);
      if (el) { if (!map.has(el)) map.set(el, []); map.get(el).push(a); }
    });
    if (!map.size || !('IntersectionObserver' in window)) return;
    const visible = new Set();
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => e.isIntersecting ? visible.add(e.target) : visible.delete(e.target));
      // La sección activa es la que ocupa la franja central de la pantalla
      let current = null;
      map.forEach((_, el) => { if (visible.has(el)) current = el; });
      links.forEach(a => { a.classList.remove('is-current'); a.removeAttribute('aria-current'); });
      if (current) map.get(current).forEach(a => { a.classList.add('is-current'); a.setAttribute('aria-current', 'true'); });
    }, { rootMargin: '-45% 0px -50% 0px' });
    map.forEach((_, el) => io.observe(el));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNav); else initNav();

  /* ---------- Lanzamiento: comprobar el código (se compara su huella SHA-256, nunca el código) ---------- */
  async function sha256(txt) {
    const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(txt));
    return [...new Uint8Array(buf)].map(b => b.toString(16).padStart(2, '0')).join('');
  }
  async function tryCode(code) {
    const cfg = window.opLaunch;
    if (!cfg || !cfg.hash || !code || !window.crypto || !crypto.subtle) return false;
    const clean = code.trim().toUpperCase();
    if (await sha256(clean) !== cfg.hash) return false;
    try { localStorage.setItem('op-access', cfg.hash); } catch (e) {}
    if (cfg.discount) fetch(root + 'discount/' + encodeURIComponent(clean), { credentials: 'same-origin' }).catch(() => {});
    document.documentElement.classList.remove('op-gated');
    return true;
  }
  function initGate() {
    if (!document.documentElement.classList.contains('op-gated')) return;
    const q = new URLSearchParams(location.search);
    const fromUrl = q.get('code');
    if (fromUrl) {
      tryCode(fromUrl).then(ok => {
        if (!ok) return;
        q.delete('code');
        history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q : '') + location.hash);
      });
    }
    const input = document.getElementById('OpGateCode');
    if (input && !fromUrl) setTimeout(() => input.focus(), 100);
  }
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-op-gate-form]');
    if (!form) return;
    e.preventDefault();
    const ok = await tryCode(form.code.value);
    const err = document.querySelector('[data-op-gate-error]');
    if (err) err.hidden = ok;
    if (!ok) {
      form.classList.remove('is-wrong'); void form.offsetWidth; form.classList.add('is-wrong');
      form.code.setAttribute('aria-invalid', 'true'); form.code.select();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGate); else initGate();
  /* Editor de temas: enseñar la pantalla de código al seleccionar la sección */
  document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('[data-op-gate]')) document.documentElement.classList.add('op-gated'); });
  document.addEventListener('shopify:section:deselect', e => { if (e.target.querySelector('[data-op-gate]')) document.documentElement.classList.remove('op-gated'); });

  const treasures = new Map();
  function initTreasure(scope) {
    if (reduce) return; // movimiento reducido: el cofre se queda estático y abierto
    scope.querySelectorAll('[data-op-treasure]').forEach(sec => {
      if (!treasures.has(sec)) treasures.set(sec, new OpTreasure(sec));
    });
  }
  document.addEventListener('shopify:section:unload', e => {
    e.target.querySelectorAll('[data-op-treasure]').forEach(sec => {
      const t = treasures.get(sec); if (t) { t.destroy(); treasures.delete(sec); }
    });
  });
  const remeasure = () => treasures.forEach(t => { t.measure(); t.request(true); });
  window.addEventListener('load', remeasure);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);

  /* Hero: el destacado empieza a la altura del titular (no del texto de colaboración) */
  function alignHero(scope) {
    scope.querySelectorAll('.op-hero__inner').forEach(inner => {
      const feat = inner.querySelector('.op-hero__feature'), title = inner.querySelector('.op-hero__title'), copy = inner.querySelector('.op-hero__copy');
      if (!feat || !title || !copy) return;
      const offset = title.getBoundingClientRect().top - copy.getBoundingClientRect().top;
      inner.style.setProperty('--op-feature-offset', Math.max(0, Math.round(offset)) + 'px');
    });
  }
  window.addEventListener('resize', () => alignHero(document));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => alignHero(document));

  function init(scope) {
    alignHero(scope);
    initVideos(scope);
    initTreasure(scope);
    initAccess(scope);
    initReveal(scope);
    scope.querySelectorAll('form.op-buy').forEach(syncSize); // el navegador puede restaurar la talla al volver atrás
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  /* Editor de temas */
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:block:select', e => {
    const d = e.target.closest && e.target.closest('details');
    if (d) d.open = true;
  });
})();
